import { useCallback, useEffect, useState } from "react";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import { Button, Divider, Empty, Modal, Popover, Card } from "antd";
import { useNavigate } from "react-router";
import SendMoneyService from "../../services/send-money.service";
import { BsThreeDotsVertical } from "react-icons/bs";
import { modeSelector } from "../../store/selectors/app.selector";
import { useSelector } from "react-redux";
import { ReactComponent as TickIcon } from "../../assests/images/tickIcon.svg";
import defaultUser from "../../assests/images/defaultuser.svg";
import { ReactComponent as AddIcon } from "../../assests/images/Add.svg";
import { useTranslation } from "react-i18next";
export default function InternalBeneList() {
  const [noRecords, setNoRecords] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [searchLoader, setSearchLoader] = useState(false);
  const [message, setMessage] = useState("");
  const [visible, setVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [payeeDetails, setPayeeDetails] = useState({});
  const mode = useSelector(modeSelector);
  const [favType, setFavType] = useState("");
  const [searchText, setSearchText] = useState("");
  const [list, setList] = useState([]);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [payeeImage, setPayeeImage] = useState("");

  useEffect(() => {
    setLoader(true);
    getAllPayee();
  }, []);

  const getAllPayee = useCallback(async () => {
    try {
      const response = await SendMoneyService.getAllPayee({ mode: mode });
      if (response.status === 200) {
        setLoader(false);
        setSearchLoader(false);
        setList(response.data["data"]["internalBeneList"]);
        setDataSource(response.data["data"]["internalBeneList"]);
        setNoRecords(
          response.data["data"]["internalBeneList"].length > 0 ? false : true
        );
      }
    } catch (error) {
      setLoader(false);
      setSearchLoader(false);
      setNoRecords(true);
    }
  }, []);

  const getPayeeImages = useCallback(async () => {
    try {
      const req = {
        mode: mode,
        accNo: dataSource.map((e) => e.beneAccNo),
      };
      const response = await SendMoneyService.getPayeeImages(req);
      if (response.status === 200) {
        setPayeeImage(response.data["data"]["imagesList"]);
      }
    } catch (error) {}
  }, [dataSource]);

  useEffect(() => {
    getPayeeImages();
  }, [getPayeeImages]);

  const addFavouritePayee = useCallback(async (option) => {
    try {
      setFavType(option?.favorites === "N" ? "Y" : "N");
      const response = await SendMoneyService.addFavouritePayee({
        reqId: option?.reqId,
        favorites: option?.favorites === "N" ? "Y" : "N",
        mode: mode,
        beneType: "INTERNAL",
      });
      if (response.status === 200) {
        //setDataSource([]);
        //getAllPayee();
        setMessage(response.data["message"]);
        setVisible(true);
      }
    } catch (error) {}
  }, []);

  const onSearch = (item) => {
    setSearchLoader(true);
    setSearchText(item);
    const transformToLower = item.toLowerCase();
    let filteredData = list.filter(function (item) {
      const beneNickName = item.beneNickName.toLowerCase();
      return beneNickName.includes(transformToLower);
    });

    if (filteredData.length === 0) {
      setDataSource([]);
      setSearchLoader(false);
      setNoRecords(true);
    } else {
      setDataSource(filteredData);
      setSearchLoader(false);
      setNoRecords(false);
    }
  };

  return (
    <>
      {/* <div className="mb-1 acc-details-header">
        <div>
          <Input.Search
            className="payee-search"
            placeholder="Beneficiary Search"
            enterButton
            value={searchText}
            loading={searchLoader}
            allowClear
            onChange={(e) => onSearch(e.target.value)}
          />
        </div>

      </div> */}

      <div className="dashboard-accounts-wrapper row">
        <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <Card
            className="transfercard mb-2"
            align="center"
            onClick={() => navigate("/add-internal-beneficary")}
          >
            <div className="mt-2">
              <AddIcon height={30} />
            </div>
            <div className="mt-2">
              <span
                style={{
                  fontSize: "12px",
                  fontWeight: 600,
                }}
              >
                {t("pages.Add_Bene.add_new", {
                  defaultValue: "Add New",
                })}
              </span>
            </div>
          </Card>
        </div>

        {dataSource.map((option, idx) => (
          <div
            key={idx}
            className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2"
          >
            <Card
              className="transfercard mb-3"
              align="center"
              onClick={() =>
                navigate("/send-money/payee-transfer", {
                  state: { ...option, mode: "PAY_LIST" },
                })
              }
            >
              <div className="mt-2">
                {payeeImage.length > 0 ? (
                  payeeImage.map((image, index) =>
                    image.beneAccNo === option.beneAccNo ? (
                      <img
                        key={index}
                        src={image?.imageData}
                        alt={option.beneNickName}
                        height={30}
                      />
                    ) : null
                  )
                ) : (
                  <img
                    key="default"
                    src={defaultUser}
                    alt={option.beneNickName}
                    height={30}
                  />
                )}
                {payeeImage.length > 0 &&
                  !payeeImage.some(
                    (image) => image.beneAccNo === option.beneAccNo
                  ) && (
                    <img
                      key="default"
                      src={defaultUser}
                      alt={option.beneNickName}
                      height={30}
                    />
                  )}
              </div>
              <div className="mt-2">
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                  }}
                  className="transfercardspan"
                  title={option?.beneNickName || "-"}
                >
                  {option.beneNickName || "-"}
                </span>
              </div>
            </Card>
          </div>
        ))}
      </div>

      <Modal
        open={visible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {" "}
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 100 }}
              onClick={() => {
                setVisible(false);
                getAllPayee();
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
